import { render, staticRenderFns } from "./ModalBlockError.vue?vue&type=template&id=c97f7cc6"
import script from "./ModalBlockError.vue?vue&type=script&lang=js"
export * from "./ModalBlockError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports